export const SUBMISSION_STATUSES = [
  {
    text: 'Failed',
    value: 'Failed',
    isEditable: true,
  },
  {
    text: 'Resubmitted',
    value: 'Resubmitted',
    isEditable: false,
  },
  {
    text: 'Submitted',
    value: 'Submitted',
    isEditable: false,
  },
  {
    text: 'Unsubmitted',
    value: 'Unsubmitted',
    isEditable: true,
  },
  {
    text: 'Pending',
    value: 'Pending',
    isEditable: false,
  },
  {
    text: 'Pending NFIA',
    value: 'Pending_NFIA',
    isEditable: false,
  },
  {
    text: 'Unsubmitted NFIA',
    value: 'Unsubmitted_NFIA',
    isEditable: true,
  },
  {
    text: 'Submitted NFIA',
    value: 'Submitted_NFIA',
    isEditable: false,
  },
  {
    text: 'Failed NFIA',
    value: 'Failed_NFIA',
    isEditable: true,
  },
  {
    text: 'Successful',
    value: 'Successful',
    isEditable: false,
  },
  {
    text: 'Successful NFIA',
    value: 'Successful_NFIA',
    isEditable: false,
  },
]
